import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { PasswordInput } from '../ui/PasswordInput';
import { Label } from '../ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Plus } from 'lucide-react';

const DEPT_ROLES = [
  'indenter',
  'dealing_assistant',
  'assistant_registrar',
  'head_of_stores',
  'scrutiny_officer',
  'section_officer',
  'purchase_officer',
  'finance_officer',
  'approving_authority',
  'auditor',
  'dean',
  'director',
  'super_admin',
];

export function CreateUserForm({ form, setForm, saving, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="grid gap-4 md:grid-cols-2">
      <div>
        <Label htmlFor="name">Name</Label>
        <Input
          id="name"
          value={form.name}
          onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
          placeholder="Enter name"
          required
        />
      </div>
      <div>
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          value={form.email}
          onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
          placeholder="email@company.com"
          required
        />
      </div>
      <div>
        <Label htmlFor="password">Password</Label>
        <PasswordInput
          id="password"
          value={form.password}
          onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
          placeholder="Enter password"
          required
        />
      </div>
      <div>
        <Label>Role</Label>
        <Select value={form.role} onValueChange={(role) => setForm((f) => ({ ...f, role }))}>
          <SelectTrigger>
            <SelectValue placeholder="Select role" />
          </SelectTrigger>
          <SelectContent>
            {DEPT_ROLES.map((role) => (
              <SelectItem key={role} value={role}>
                {role.replace(/_/g, ' ')}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="md:col-span-2">
        <Button type="submit" disabled={saving}>
          <Plus className="h-4 w-4 mr-2" />
          {saving ? 'Creating…' : 'Create user'}
        </Button>
      </div>
    </form>
  );
}
